import './OfferStatView.css';

import React from 'react';

import { Typography } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

import { declensionByNumber } from '@search/helpers/src/declensionByNumber';
import classname from '@search/classname/src';

const cn = classname.bind(null, 'OfferStatView');

export function OfferStatView({ isMobile, offerViews, offerViewsPerDay }: {
    offerViews: number;
    offerViewsPerDay?: number | null;
    isMobile?: boolean;
}) {
    const offerViewsText = ! offerViews ? undefined : `${offerViews} ${
        declensionByNumber(offerViews, [ 'просмотр', 'просмотра', 'просмотров' ])
    }, ${offerViewsPerDay ?? 0} за сегодня`;

    if (isMobile) {
        return (
            <Typography color='black-400' variant='primary' className={cn()}>
                {offerViewsText}
            </Typography>
        );
    }

    return (
        <Typography color='black-400' className={cn()}>
            <span className={cn('icon')}>
                <Icon size='s' name='eye' />
            </span>
            <span>
                {offerViewsText}
            </span>
        </Typography>
    );
}
